import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3616e331&scoped=true"
import script from "./Index.ts?vue&type=script&lang=js&external"
export * from "./Index.ts?vue&type=script&lang=js&external"
import style0 from "./Index.less?vue&type=style&index=0&id=3616e331&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3616e331",
  null
  
)

export default component.exports